import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { formatNumber } from "utils/currencyFormat";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ReactDropdown from "react-dropdown";
import userApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import {
  getListQuanLyThuChiNgoaiLe,
  updateDataSearch,
} from "../../../actions/QuanLyThuChiNgoaiLe";
import QuanLyThuChiNgoaiLeApi from "../../../service/quanLyThuChiNgoaiLeApi";
import CauHinhApi from "service/cauHinhApi";
import cauHinh from "utils/cauHinh";
export const SearchDesktop = ({}) => {
  const dispatch = useDispatch();

  const DanhSachLoai = {
    loaiOption: [
      {
        label: "Loại phiếu",
        value: "0",
      },
      {
        label: "Nhập hàng",
        value: "NH",
      },
      {
        label: "Bán hàng",
        value: "BH",
      },
      {
        label: "Phí sản xuất",
        value: "PSX",
      },
    ],
  };
  const [listLoai, setListLoai] = useState(DanhSachLoai.loaiOption);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
    QuanLyThuChiNgoaiLeApi.totalLoaiThuChi().then((response) => {
      const dataComboLoai = response.data.map((item) => ({
        value: item.Value,
        label: item.Text,
      }));
      setListLoai(dataComboLoai);
    });

    if (isLoading) {
      CauHinhApi.getConfigSys1().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const cauHinhMuaBan = response.data.find(
              (e) => e.keyConfig.toUpperCase() === "ISQUANLYMUABAN"
            );
            if (cauHinhMuaBan) {
              if (cauHinhMuaBan.valueConfig == "1") setIsQuanLyMuaBan(true);
            }
          }
        }
      });
      setIsLoading(false);
    }
  }, []);

  const DanhSachCombo = {
    nhanVienOption: [
      {
        label: "Test828@gmail.com",
        value: "Test828@gmail.com",
      },
      {
        label: "Test@gmail.com",
        value: "Test@gmail.com",
        selected: true,
      },
    ],
  };
  const [listUser, setListUser] = useState(DanhSachCombo.nhanVienOption);
  const [isQuanLyMuaBan, setIsQuanLyMuaBan] = useState(false);
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe
  );
  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    dataSearch.pageIndex = 1;
    dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  // convert sự kiện tìm kiếm từ ngày đến ngày
  var tungay = currentDate();
  if (dataSearch.tungay === "01/01/2001") tungay = "";
  else tungay = dataSearch.tungay;
  var denngay = currentDate();
  if (dataSearch.denngay === "01/01/4000") denngay = "";
  else denngay = dataSearch.denngay;
  denngay = convertDate(denngay);
  tungay = convertDate(tungay);
  return (
    <div className="search-new hidden-mobile-main show-table-main">
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Tìm kiếm</label>
        <input
          type="text"
          className="form-control input-sm"
          value={dataSearch.ten}
          onChange={updateTextValue("ten")}
          onKeyDown={handleKeyDown}
          placeholder="Người nhận/Nộp tiền"
        />
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Từ ngày</label>
        <DateTimePicker
          value={tungay}
          onChange={onChangeDate("tungay")}
          placeholder="Từ ngày"
          name="tungay"
        ></DateTimePicker>
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Đến ngày</label>
        <DateTimePicker
          value={denngay}
          onChange={onChangeDate("denngay")}
          placeholder="Đến ngày"
          name="denngay"
        ></DateTimePicker>
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Nhân viên</label>
        <select
          name="nhanvien"
          className="selectBox form-control input-sm"
          value={dataSearch.nhanvien}
          onChange={updateDropdown("nhanvien")}
        >
          {listUser &&
            listUser.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Loại phiếu</label>
        <select
          name="nhanvien"
          className="selectBox form-control input-sm"
          value={dataSearch.loaiphieu}
          onChange={updateDropdown("loaiphieu")}
        >
          {listLoai &&
            listLoai.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>
      {isQuanLyMuaBan && (
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">
            Hình thức thanh toán
          </label>
          <select
            name="BeforeAfter"
            className="form-control input-sm select-v2"
            onChange={updateDropdown("hinhThucThanhToan")}
            value={dataSearch.hinhThucThanhToan}
          >
            <option value="-1">Tất cả</option>
            <option value="0">Tiền mặt</option>
            <option value="1">Chuyển khoản</option>
          </select>
        </div>
      )}

      <div className="input-sm-new input-new-18 search-main-new">
        <button
          type="submit"
          className="btn btn-info-new btn-seach-ds"
          onClick={onSearch}
        >
          <i className="la la-search"></i>
          <span> &nbsp; Tìm kiếm</span>
        </button>
      </div>
    </div>
  );
};
